import { combineReducers } from 'redux';
import { DEFAULT_REDUCERS } from '@nsd/fe';
import dealerAccountReducer from './dealerReducer';
import claimReducer from './claimReducer';

// Developer adds their own reducers before spreading
// in the DEFAULT_REDUCERS to not overwrite any needed keys
const rootReducer = combineReducers({
  ...DEFAULT_REDUCERS,
  dealerAccount: dealerAccountReducer,
  claims: claimReducer
});

export default rootReducer;
